<div
  class="w-full h-full flex align-items-center justify-content-center page-container"
>
  <div class="login-page"></div>
  <div class="login-container shadow-5">
    <div class="login-card">
      <!-- Login with Microsoft and Google Buttons -->
      @if (isLoginButtonVisible) {
        <ng-container>
          <via-auth-header>
            <div subHeader>Welcome to <b>LIMA</b></div>
          </via-auth-header>
          <form>
            <div>
              <div class="col-12">
                <ng-container
                  *ngTemplateOutlet="
                    ssoButtons;
                    context: {
                      sso: SSOProvider.Microsoft,
                      icon: 'assets/images/microsoft-icon.svg',
                      label:
                        'Continue with <b class=\'logo\'>Microsoft</b> Account'
                    }
                  "
                ></ng-container>

                <!-- <ng-container
                *ngTemplateOutlet="
                  ssoButtons;
                  context: {
                    sso: SSOProvider.Google,
                    icon: 'assets/images/google-color-icon.svg',
                    label:
                      'Continue with <b class=\'logo\'>Google</b> Account&nbsp;&nbsp;&nbsp;'
                  }
                "
              ></ng-container> -->
                <ng-container
                  *ngTemplateOutlet="
                    ssoButtons;
                    context: {
                      sso: SSOProvider.Email,
                      icon: 'assets/images/email_icon.png',
                      label:
                        'Continue with <b class=\'logo\'>Email</b> and OTP&nbsp;&nbsp;&nbsp;'
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </form>
        </ng-container>
      } @else {
        <div class="col-12 h-1 text-lg">Validating Credentials...</div>
      }
    </div>
  </div>
</div>

<ng-template #ssoButtons let-sso="sso" let-icon="icon" let-label="label">
  <div
    class="border-round sso-button mt-3 p-2 cursor-pointer center flex align-items-center justify-content-start"
    (click)="loginWithSSO(sso)"
  >
    <span class="w-2 flex justify-content-center">
      <img [src]="icon" alt="Google Icon" class="logo" />
    </span>

    <span [innerHTML]="label"></span>
  </div>
</ng-template>
